import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL;

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const { user, restaurantId } = useAuth();

  useEffect(() => {
    if (user && restaurantId) {
      const newSocket = io(SOCKET_URL, {
        // FIX #1: Try websocket first (fast), fall back to polling only if needed.
        // Previous order ['polling', 'websocket'] caused a slow HTTP handshake
        // on every connection before upgrading to websocket.
        transports: ['websocket', 'polling']
      });

      newSocket.on('connect', () => {
        console.log('Socket connected');
        newSocket.emit('join_room', { room: user.role, restaurant_id: restaurantId });
      });

      newSocket.on('reconnect', () => {
        console.log('Socket reconnected, rejoining room');
        newSocket.emit('join_room', { room: user.role, restaurant_id: restaurantId });
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
      };
    }
  }, [user, restaurantId]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
